import { SelectionModel } from "@angular/cdk/collections";
import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";

export interface colisElement {
  descriptioncollis: string;
}

@Component({
  selector: "app-partitionmodal",
  templateUrl: "./partitionmodal.component.html",
  styleUrls: ["./partitionmodal.component.css"],
})
export class PartitionmodalComponent implements OnInit {
  quantiteenvoye: any;

  displayedColumns: string[] = ["select", "id", "description"];
  dataSource = new MatTableDataSource<colisElement>();
  selection = new SelectionModel<colisElement>(true, []);
  colis: colisElement[] = [];
  multipleColis: boolean = false;

  constructor(
    private dialogref: MatDialogRef<PartitionmodalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.quantiteenvoye = this.data.quantitereste;
    if (this.data.descriptioncollis.includes("+")) {
      this.multipleColis = true;
      this.constructColisArrayList();
    } else {
      this.multipleColis = false;
    }
  }

  getpartitionid(data: any, event: any): any {
    // console.log(event);
    this.quantiteenvoye = event;
  }

  save(): any {
    const selectedColis = this.selection.selected.join("+");
    const obj = {
      colis: selectedColis,
      quantiteenvoye: this.quantiteenvoye,
    };
    this.colis = [];
    this.dialogref.close(obj);
  }

  close(): any {
    this.dialogref.close(0);
  }

  constructColisArrayList() {
    this.colis = this.data.descriptioncollis.split("+");
    if (
      this.data?.listbordereau != null &&
      this.data?.listbordereau?.length > 0
    ) {
      const listBordereauColisExpedie = this.data.listbordereau.map(
        (item: any) => item.colisExpedieDesc
      );

      this.colis = this.colis.filter(
        (colisItem) => !listBordereauColisExpedie.includes(colisItem)
      );
    }
    this.dataSource = new MatTableDataSource<colisElement>(this.colis);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
    // console.log("selected:: ", this.selection.selected.join("+"));
  }
}
